export default {
  height: 'auto',
  calcHeight: 'auto',
  sarchShow: true,
  searchMenuSpan: 6,
  tip: false,
  border: true,
  index: true,
  indexLabel: '序号',

  viewBtn: false,
  selection: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,

  column: [
    {
      label: '交易时间',
      prop: 'tradeTime',
      type: 'datetime',
      searchRange: true,
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      searchSpan: 8,

      rules: [
        {
          required: true,
          message: '请输入交易时间',
          trigger: 'change',
        },
      ],
    },
    {
      label: '商户订单号',
      prop: 'mchOrderNo',
      search: true,
      searchLabelWidth: 100,
      rules: [
        {
          required: true,
          message: '请输入商户订单号',
          trigger: 'change',
        },
      ],
    },
    {
      label: '支付渠道',
      prop: 'payPlatform',
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=payChannel',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      width: 120,
      rules: [
        {
          required: true,
          message: '请输入支付渠道',
          trigger: 'change',
        },
      ],
    },
    {
      label: '支付场景',
      prop: 'payScene',
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=payScene',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      width: 120,
      rules: [
        {
          required: false,
          message: '请输入支付场景',
          trigger: 'change',
        },
      ],
    },
    {
      label: '商品分类',
      prop: 'goodsType',
      rules: [
        {
          required: true,
          message: '请输入商品分类',
          trigger: 'change',
        },
      ],
    },
    {
      label: '交易状态',
      prop: 'tradeStatus',
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=tradeStatus',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      width: 120,
      rules: [
        {
          required: true,
          message: '请输入交易状态',
          trigger: 'change',
        },
      ],
    },
    {
      label: '订单金额(元)',
      prop: 'totalFee',
      rules: [
        {
          required: true,
          message: '请输入订单金额(元)',
          trigger: 'change',
        },
      ],
    },
  ],
};
